import { memo, useMemo } from 'react';
import LeadsTable from 'components/elements/LeadsTable';
import { Pagination } from 'components/layout/List/Paging';
import TotalProjectsFoundBanner from 'components/widgets/TotalProjectsFoundBanner';
import { useMapProjectList } from 'hooks/projectMap/useMapProjectList';
import { usePaginate } from 'hooks/usePaginate';
import { usePolygonBounds } from 'state/dashboard';

const GroupEditLeadsTable = () => {
  const {
    page: currentPage,
    previousPage,
    nextPage,
    setPageNumber,
    calcTotalPages,
  } = usePaginate();
  const [polygonBounds] = usePolygonBounds();

  const { projectList } = useMapProjectList({
    overrideBounds: polygonBounds,
    useMapFiltersOnly: true,
  });

  const projectsCount = projectList?.data?.count || 0;

  const totalPages = useMemo(() => {
    return calcTotalPages(projectsCount) || 1;
  }, [projectsCount]);

  return (
    <>
      <TotalProjectsFoundBanner projectsCount={projectsCount} />
      <LeadsTable
        items={projectList.data?.projects || []}
        hasClickableRows={false}
        isLoading={projectList.isLoading || projectList.isFetching}
        footer={
          <Pagination
            currentPage={currentPage}
            isLoading={projectList.isLoading}
            setPage={(pageNumber) => setPageNumber(pageNumber)}
            totalPages={totalPages}
            onNext={() => nextPage()}
            onPrev={() => previousPage()}
          />
        }
      />
    </>
  );
};

export default memo(GroupEditLeadsTable);
